import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';


@Injectable()
export class UfService {

    constructor(private http: HttpClient) { }

    getUf(){
    return this.http.get<any>('assets/demo/uf.json')
        .toPromise()
        .then(res => res.data as any[])
        .then(data => data);
    }
}